import React from "react";

const CloseIconStroke = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path d="M12.5 3.5L3.5 12.5M3.5 3.5L12.5 12.5" stroke="#3A383F" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export default CloseIconStroke;
